import { literal, object, parse, type InferOutput } from 'valibot'
import { deepClone } from '../../../../../deep_clone'
import isNil from '../../../../../ldsh/isNil'
import { Engine } from '../../../../engine/Engine.type'
import { EntityIdSchema } from '../../../../entity/EntityId.type'
import { FactoryEntitySchema, type FactoryEntity } from '../../../../entity/EntityType/Factory'
import entityTypeMetaList from '../../../../entity/entityTypeMetaList.generated'
import type { EntityUnionForFactory } from '../../../../entity/EntityUnionForFactory.type'
import findById from '../../../../findById'
import findByIdOrThrow from '../../../../findByIdOrThrow'
import { samePosition } from '../../../../tile_position_xy/samePosition'
import type { HasWasBuiltThisTurn } from '../../../../WasBuiltThisTurn'
import type { ActionLog } from '../../ActionLog.type'
import { ActionType } from '../ActionType'

export const CancelFactoryOrderActionSchema = object({
  type: literal(ActionType.Game.CancelFactoryOrder),
  factory_id: EntityIdSchema,
})

export type CancelFactoryOrderAction = InferOutput<typeof CancelFactoryOrderActionSchema>

export function createCancelFactoryOrderAction(
  factoryEntity: FactoryEntity
): CancelFactoryOrderAction {
  return {
    type: ActionType.Game.CancelFactoryOrder,
    factory_id: factoryEntity.id,
  }
}

export async function handleCancelFactoryOrderAction(
  engine: Engine,
  action: CancelFactoryOrderAction,
  actionLog: ActionLog
): Promise<void> {
  const { factory_id } = action
  const { state } = engine
  const { ents, players, turnPlayerId } = state

  const factoryEntity = parse(
    FactoryEntitySchema,
    findById(ents, factory_id)
  )
  const { player_id } = factoryEntity
  if (player_id !== turnPlayerId) {
    throw new Error('Unexpected player_id !== turnPlayerId')
  }
  const player = findByIdOrThrow(players, player_id)

  actionLog.factory0 = deepClone(factoryEntity)

  const entToCancel = ents.find((entity): entity is EntityUnionForFactory => {
    return ((entity as HasWasBuiltThisTurn).builtThisTurn as boolean) && samePosition(factoryEntity, entity)
  })

  if (!entToCancel) {
    // throw new Error('Unexpected !entToCancel')
    // no action necessary
    return
  }
  actionLog.unit0 = deepClone(entToCancel)

  const entityTypeMeta = findByIdOrThrow(entityTypeMetaList, entToCancel.etype_id)
  const refundAmount = entityTypeMeta.price
  // rule out undefined
  if (isNil(refundAmount)) {
    throw new Error('No Refunds')
  }

  state.ents = ents.filter((ent1) => ent1.id !== entToCancel.id)
  player.money += refundAmount
}
